import { Badge } from "@/components/ui/badge";
import { ConvertStatusById } from "@/utils/convert-status-to-name/convert-status-to-name";
import { UpdatedPrivateOfficeBadgeProps } from "./updated-private-office-badge.types";

export const UpdatedPrivateOfficeBadge = ({
  date,
  dateAcknowledge,
  days,
}: UpdatedPrivateOfficeBadgeProps) => {
  const type = "STATUS_PRIVATE_OFFICE_UPDATED_DAYS";

  if (days !== undefined) {
    if (days === null) return <Badge variant="secondary">-</Badge>;
    let status = 1;
    if (days > 30 && days <= 60) status = 2;
    else if (days > 60) status = 3;
    const CURRENT_STATUS_BADGE = ConvertStatusById({ status, type });
    return (
      <Badge variant={CURRENT_STATUS_BADGE?.badge_color}>
        {days === 0 ? "Hoje" : `${days} ${days === 1 ? "dia" : "dias"}`}
      </Badge>
    );
  }

  const today = new Date();
  const dataUpdatedAt = new Date(date);
  const acknowledgeDate = dateAcknowledge ? new Date(dateAcknowledge) : null;

  if (isNaN(dataUpdatedAt.getTime())) {
    return <Badge variant="secondary">-</Badge>;
  }

  const lastDay =
    acknowledgeDate && acknowledgeDate > dataUpdatedAt
      ? acknowledgeDate
      : dataUpdatedAt;

  // Calculate difference considering only dates (without time)
  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const lastDayStart = new Date(
    lastDay.getFullYear(),
    lastDay.getMonth(),
    lastDay.getDate(),
  );

  const oneDay = 24 * 60 * 60 * 1000;
  const diffInMs = todayStart.getTime() - lastDayStart.getTime();
  const countDays = Math.floor(diffInMs / oneDay);

  let status = 1; // green (0-30 days)
  if (countDays > 30 && countDays <= 60) {
    status = 2; // yellow (31-60 days)
  } else if (countDays > 60) {
    status = 3; // red (61+ days)
  }

  const CURRENT_STATUS_BADGE = ConvertStatusById({ status, type });

  return (
    <Badge variant={CURRENT_STATUS_BADGE?.badge_color}>
      {countDays === 0
        ? "Hoje"
        : `${countDays} ${countDays === 1 ? "dia" : "dias"}`}
    </Badge>
  );
};
